import { put } from 'redux-saga/effects'
import { replaceUser, replaceUserFailed, replaceUserSuccess } from '../actions'
import { enterpriseReplaceUsers } from '../../../utils/api'

export function* replaceUserHandler(data) {
  try {
    replaceUser(data)
    const response = yield enterpriseReplaceUsers(data)
    yield put(replaceUserSuccess(response.data))
  } catch (error) {
    yield put(replaceUserFailed(error))
  }
}
